export function createReadonlyStoreField<T>(field: Ref<T>) {
  return computed<Readonly<T>>(() => field.value)
}
